<!-- Иконка перехода к следующему месяцу календаря. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <polyline points="9 18 15 12 9 6" :stroke="stroke" stroke-width="2" />
  </svg>
</template>

<script>
export default {
  name: "CalendarNextIcon",

  props: {
    size: { type: [Number, String], default: 20 },
    stroke: { type: String, default: "currentColor" },
  },
};
</script>
